var _class, _MapServerStratum, _class2, _ArcGisMapServerCatalogGroup;
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import i18next from "i18next";
import { action, computed, makeObservable, override, runInAction } from "mobx";
import URI from "urijs";
import filterOutUndefined from "../../../Core/filterOutUndefined";
import isDefined from "../../../Core/isDefined";
import loadJson from "../../../Core/loadJson";
import replaceUnderscores from "../../../Core/replaceUnderscores";
import runLater from "../../../Core/runLater";
import { networkRequestError } from "../../../Core/TerriaError";
import CatalogMemberMixin from "../../../ModelMixins/CatalogMemberMixin";
import GroupMixin from "../../../ModelMixins/GroupMixin";
import UrlMixin from "../../../ModelMixins/UrlMixin";
import ArcGisMapServerCatalogGroupTraits from "../../../Traits/TraitsClasses/ArcGisMapServerCatalogGroupTraits";
import { InfoSectionTraits } from "../../../Traits/TraitsClasses/CatalogMemberTraits";
import CommonStrata from "../../Definition/CommonStrata";
import CreateModel from "../../Definition/CreateModel";
import createStratumInstance from "../../Definition/createStratumInstance";
import LoadableStratum from "../../Definition/LoadableStratum";
import StratumOrder from "../../Definition/StratumOrder";
import proxyCatalogItemUrl from "../proxyCatalogItemUrl";
import ArcGisMapServerCatalogItem from "./ArcGisMapServerCatalogItem";

/** The ID we add to our "All layers" ArcGisMapServerCatalogItem if MapServer.singleFusedMapCache is true */
const SINGLE_FUSED_MAP_CACHE_ID = "all-layers";
export let MapServerStratum = (_class = (_MapServerStratum = class MapServerStratum extends LoadableStratum(ArcGisMapServerCatalogGroupTraits) {
  constructor(_catalogGroup, _mapServer) {
    super();
    this._catalogGroup = _catalogGroup;
    this._mapServer = _mapServer;
    makeObservable(this);
  }
  duplicateLoadableStratum(model) {
    return new MapServerStratum(model, this._mapServer);
  }

  /** returns an array of the parent layers id's */
  findParentLayers(layerId) {
    const parentLayerIds = [];
    const layer = this.layers.find(l => l.id === layerId);
    if (layer !== undefined) {
      parentLayerIds.push(layer.id);
      if (layer.parentLayerId !== -1) {
        parentLayerIds.push(...this.findParentLayers(layer.parentLayerId));
      }
    }
    return parentLayerIds;
  }
  get name() {
    if (this._mapServer.documentInfo && this._mapServer.documentInfo.Title && this._mapServer.documentInfo.Title.length > 0) {
      return replaceUnderscores(this._mapServer.documentInfo.Title);
    }
  }
  get info() {
    return [createStratumInstance(InfoSectionTraits, {
      name: i18next.t("models.arcGisMapServerCatalogGroup.serviceDescription"),
      content: this._mapServer.serviceDescription
    }), createStratumInstance(InfoSectionTraits, {
      name: i18next.t("models.arcGisMapServerCatalogGroup.dataDescription"),
      content: this._mapServer.description
    }), createStratumInstance(InfoSectionTraits, {
      name: i18next.t("models.arcGisMapServerCatalogGroup.copyrightText"),
      content: this._mapServer.copyrightText
    })];
  }
  get dataCustodian() {
    if (this._mapServer.documentInfo && this._mapServer.documentInfo.Author && this._mapServer.documentInfo.Author.length > 0) {
      return this._mapServer.documentInfo.Author;
    }
  }
  static async load(catalogGroup) {
    const uri = new URI(catalogGroup.url).addQuery("f", "json");
    if (catalogGroup.token) {
      uri.addQuery("token", catalogGroup.token);
    }
    const mapServer = await loadJson(proxyCatalogItemUrl(catalogGroup, uri.toString()));

    // Is this really a MapServer REST response?
    if (!mapServer || !mapServer.layers && !mapServer.subLayers) {
      throw networkRequestError({
        title: i18next.t("models.arcGisMapServerCatalogGroup.invalidServiceTitle"),
        message: i18next.t("models.arcGisMapServerCatalogGroup.invalidServiceMessage")
      });
    }
    const stratum = new MapServerStratum(catalogGroup, mapServer);
    return stratum;
  }
  get tilesOnly() {
    var _this$_mapServer$capa;
    return this._mapServer.singleFusedMapCache && ((_this$_mapServer$capa = this._mapServer.capabilities) === null || _this$_mapServer$capa === void 0 ? void 0 : _this$_mapServer$capa.includes("TilesOnly"));
  }
  get members() {
    if (this.tilesOnly) {
      return ["".concat(this._catalogGroup.uniqueId, "/").concat(SINGLE_FUSED_MAP_CACHE_ID)];
    }
    return filterOutUndefined(this.layers.map(layer => {
      if (!isDefined(layer.id) || layer.parentLayerId !== -1) {
        return undefined;
      }
      return this._catalogGroup.uniqueId + "/" + layer.id;
    }).concat(this.subLayers.map(subLayer => {
      if (!isDefined(subLayer.id)) {
        return undefined;
      }
      return this._catalogGroup.uniqueId + "/" + subLayer.id;
    })));
  }
  get layers() {
    return this._mapServer.layers || [];
  }
  get subLayers() {
    return this._mapServer.subLayers || [];
  }
  createMembersFromLayers() {
    if (this.tilesOnly) this.createMemberForSingleFusedMapCache();else this.layers.forEach(layer => this.createMemberFromLayer(layer));
  }
  createMemberForSingleFusedMapCache() {
    const id = "".concat(this._catalogGroup.uniqueId, "/").concat(SINGLE_FUSED_MAP_CACHE_ID);
    let model = this._catalogGroup.terria.getModelById(ArcGisMapServerCatalogItem, id);
    if (model === undefined) {
      model = new ArcGisMapServerCatalogItem(id, this._catalogGroup.terria);
      this._catalogGroup.terria.addModel(model);
    }

    // Replace the stratum inherited from the parent group.
    model.strata.delete(CommonStrata.definition);
    model.setTrait(CommonStrata.definition, "name", i18next.t("models.arcGisMapServerCatalogGroup.singleFusedMapCacheLayerName").toString());
    model.setTrait(CommonStrata.definition, "url", this._catalogGroup.url);
    if (this._catalogGroup.token) {
      model.setTrait(CommonStrata.definition, "token", this._catalogGroup.token);
    }
  }
  createMemberFromLayer(layer) {
    if (!isDefined(layer.id)) {
      return;
    }
    const id = this._catalogGroup.uniqueId;
    let layerId = id + "/" + layer.id;
    const parentLayers = this.findParentLayers(layer.id);
    if (parentLayers.length > 0) {
      layerId = id + "/" + parentLayers.reverse().join("/");
    }
    let model;

    // Treat layer as a group if it has type "Group Layer" - or has subLayers
    if (layer.type === "Group Layer" || Array.isArray(layer.subLayerIds) && layer.subLayerIds.length > 0) {
      const existingModel = this._catalogGroup.terria.getModelById(ArcGisMapServerCatalogGroup, layerId);
      if (existingModel === undefined) {
        model = new ArcGisMapServerCatalogGroup(layerId, this._catalogGroup.terria);
        this._catalogGroup.terria.addModel(model);
      } else {
        model = existingModel;
      }
    } else {
      const existingModel = this._catalogGroup.terria.getModelById(ArcGisMapServerCatalogItem, layerId);
      if (existingModel === undefined) {
        model = new ArcGisMapServerCatalogItem(layerId, this._catalogGroup.terria);
        this._catalogGroup.terria.addModel(model);
      } else {
        model = existingModel;
      }
    }

    // Replace the stratum inherited from the parent group.
    model.strata.delete(CommonStrata.definition);
    model.setTrait(CommonStrata.definition, "name", replaceUnderscores(layer.name));
    const uri = new URI(this._catalogGroup.url).segment(layer.id.toString()); // Convert layer id to string as segment(0) means something different.
    model.setTrait(CommonStrata.definition, "url", uri.toString());
    if (this._catalogGroup.token) {
      if (model instanceof ArcGisMapServerCatalogItem) model.setTrait(CommonStrata.definition, "token", this._catalogGroup.token);
      if (model instanceof ArcGisMapServerCatalogGroup) model.setTrait(CommonStrata.definition, "token", this._catalogGroup.token);
    }
  }
}, _defineProperty(_MapServerStratum, "stratumName", "mapServer"), _MapServerStratum), _applyDecoratedDescriptor(_class.prototype, "name", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "name"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "info", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "info"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dataCustodian", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "dataCustodian"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "tilesOnly", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "tilesOnly"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "members", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "members"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createMembersFromLayers", [action], Object.getOwnPropertyDescriptor(_class.prototype, "createMembersFromLayers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createMemberForSingleFusedMapCache", [action], Object.getOwnPropertyDescriptor(_class.prototype, "createMemberForSingleFusedMapCache"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createMemberFromLayer", [action], Object.getOwnPropertyDescriptor(_class.prototype, "createMemberFromLayer"), _class.prototype), _class);
StratumOrder.addLoadStratum(MapServerStratum.stratumName);
let ArcGisMapServerCatalogGroup = (_class2 = (_ArcGisMapServerCatalogGroup = class ArcGisMapServerCatalogGroup extends UrlMixin(GroupMixin(CatalogMemberMixin(CreateModel(ArcGisMapServerCatalogGroupTraits)))) {
  constructor() {
    super(...arguments);
    makeObservable(this);
  }
  get type() {
    return ArcGisMapServerCatalogGroup.type;
  }
  get typeName() {
    return i18next.t("models.arcGisMapServerCatalogGroup.name");
  }
  get cacheDuration() {
    if (isDefined(super.cacheDuration)) {
      return super.cacheDuration;
    }
    return "1d";
  }
  async forceLoadMetadata() {
    const stratum = await MapServerStratum.load(this);
    runInAction(() => {
      this.strata.set(MapServerStratum.stratumName, stratum);
    });
  }
  async forceLoadMembers() {
    const mapServerStratum = this.strata.get(MapServerStratum.stratumName);
    if (mapServerStratum) {
      await runLater(() => mapServerStratum.createMembersFromLayers());
    }
  }
}, _defineProperty(_ArcGisMapServerCatalogGroup, "type", "esri-mapServer-group"), _ArcGisMapServerCatalogGroup), _applyDecoratedDescriptor(_class2.prototype, "cacheDuration", [override], Object.getOwnPropertyDescriptor(_class2.prototype, "cacheDuration"), _class2.prototype), _class2);
export { ArcGisMapServerCatalogGroup as default };